import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ExampleIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 82.754 45",
    fill: color,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 0h33.943v8.811H9.835v9.128h21.214v8.806H9.835v9.449h24.429V45H0zM82.11 0L67.071 21.985 82.751 45H71.182L61.095 29.575 50.938 45H39.683l15.688-22.886L40.332 0h11.566l9.385 14.594L70.861 0z"
    })
  });
};

export { PM2ExampleIcon };
//# sourceMappingURL=example.js.map
